import { identity, mapKeys, mapValues, snakeCase, startCase, toLower } from 'lodash-es';

export interface EventProperties {
  [key: string]: (string | number)[] | string | number;
}

const titleCase = (str?: string) => startCase(toLower(str));

const transformEventValue = (value: string | number | (string | number)[]): string | number | (string | number)[] => {
  if (typeof value === 'string') {
    return titleCase(value);
  } else if (Array.isArray(value)) {
    return value.map(item => (typeof item === 'string' ? titleCase(item) : item));
  }
  return value;
};
/**
 * Transforms the event properties object to a new object with:
 * - snake_cased keys,
 * - transformed strings and strings arrays values into title-cased.
 *
 * @param eventProperties - The event properties object to transform.
 * @param valueTransformer - The function to transform the keys of the event properties object. @see mapValues second param.
 * @returns The transformed event properties object.
 */
export const transformedEventProperties = (
  eventProperties: EventProperties,
  valueTransformer: null | ((...a: never[]) => unknown) = transformEventValue,
): Record<string, unknown> =>
  eventProperties
    ? mapValues(
        mapKeys(eventProperties, (_value, key) => snakeCase(key)),
        valueTransformer ?? identity,
      )
    : {};
